<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    id="modal-terms-condition"
    :class="`${isValidTerms && statusTerms ? 'uk-flex-top uk-modal uk-flex uk-open' : 'uk-modal'}`"
    uk-modal
    bg-close="false"
  >
    <div :class="`uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-text-left`">
      <h2 class="uk-modal-title">
        {{ title || 'Syarat dan Ketentuan' }}
      </h2>
      <div class="terms-condition-body">
        <div
          v-if="detailTermsCondition?.isLoading"
          class="uk-text-center uk-margin-top"
        >
          <div uk-spinner />
        </div>

        <div v-else>
          <div
            class="terms-condition-description"
            v-html="description"
          />
        </div>

        <div class="uk-margin-top">
          <div class="uk-flex uk-flex-between">
            <div class="uk-flex uk-flex-middle">
              <div class="checkbox-item uk-margin-small-right">
                <input
                  v-model="agreeTerms"
                  type="checkbox"
                  :name="`checkbox-terms`"
                >
              </div>
              <div class="agreement-terms">
                Setuju
              </div>
            </div>
            <div>
              <button 
                class="uk-button blue"
                :class="agreeTerms ? '' : 'disabled'"
                :disabled="!agreeTerms"
                @click="handleUpdatedTerms"
              >
                Setuju
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { notificationDanger } from '@/utils/notification'

export default {
  props: {
    isValidTerms: {
      required: true,
      type: Boolean
    },
    user: {
      required: true,
      type: Object
    }
  },
  data(){
    return{
      agreeTerms: false,
      user_id: '',
      title: '',
      description: '',
      statusTerms: false
    }
  },
  computed: {
    ...mapGetters({
      detailTermsCondition: 'termsCondition/get_detail_terms_condition'
    })
  },
  watch: {
    agreeTerms() {
      this.user_id = this.user?.user_id || ''
    },
    detailTermsCondition(val) {
      if(!val?.isLoading && val?.data) {
        this.title = val?.data[0]?.data?.title
        this.description = val?.data[0]?.data?.description
        this.statusTerms = val?.data[0]?.status?.name?.toUpperCase() == 'ACTIVE' ? true : false
      }
    }
  },
  async mounted() {
    await this.actionGetDetailTermsCondition({ category: 'TNC' })
  },
  methods: {
    ...mapActions({
      actionGetUserProfile: 'auth/getUserProfile',
      actionGetDetailTermsCondition: 'termsCondition/getDetailTermsCondition',
      updateStatusTermsCondition: 'termsCondition/updateStatusTermsCondition'
    }),
    handleUpdatedTerms() {
      this.updateStatusTermsCondition({ user_id: this.user_id })
        .then((result) => {
          if(result?.status == 201 || result?.status == 200){
            this.actionGetUserProfile()
          }
        })
        .catch(error => {
          notificationDanger(error?.response?.data?.message || 'Error Update Syarat dan Ketentuan')
        })
        .finally(() => {
          setTimeout(() => {
            location.reload()
          }, 500)
        })
    }
  }
}
</script>

<style scoped>
  .uk-modal-body {
    width: 900px;
    max-width: min(900px, 95vw);
    height: auto;
    max-height: 85vh;
    overflow-y: auto;
    padding: 30px;
    box-shadow: 0px 8px 40px rgba(12, 50, 96, 0.05);
    border-radius: 16px;
  }
  .uk-modal-title {
    font-family: 'PoppinsBold';
    font-weight: 700;
    font-size: 20px;
    color: #004FA4;
    text-align: center;
    margin-bottom: 0px;
  }
  .uk-modal-close {
    margin-right: 16px;
  }
  .checkbox-item {
    margin-top: 5px;
  }
  .agreement-terms {
    font-family: 'Poppins';
    font-weight: 500;
    font-size: 14px;
    color: #000;
  }
  .terms-condition-description {
    font-family: 'Poppins';
  }
  .terms-condition-body{
    position: relative;
    height: 410px;
    padding: 15px 20px;
    margin: 20px 0px;
    border-radius: 8px;
    border: 1px solid #d8d8d8;
    overflow: scroll;
  }
</style>
